module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/LeaveRequestModal.ejs -->\n<div class="modal-dialog modal-leave-request">\n<div class="modal-content animated sweet">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal">\n            <span aria-hidden="true">×</span>\n            <span class="sr-only">Close</span>\n        </button>\n        <div class="modal-title">\n            '+
((__t=( model.getEmployee().get('fullName') ))==null?'':_.escape(__t))+
'\n        </div>\n    </div>\n    <div class="modal-body js-leave">\n        <h3>'+
((__t=( leaveType.get('name') ))==null?'':_.escape(__t))+
'</h3>\n        <div class="period">'+
((__t=( period ))==null?'':_.escape(__t))+
'</div>\n\n        ';
 if (model.attachments.length) { 
__p+='\n            <div class="attachments '+
((__t=( model.attachments.length ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n                ';
 model.attachments.each(function(attachment) { 
__p+='\n                    <a href="'+
((__t=( attachment.downloadUrl() ))==null?'':_.escape(__t))+
'"\n                        target="_blank">\n                        <i class="fa fa-file"></i>\n                        '+
((__t=( attachment.get('name') ))==null?'':_.escape(__t))+
'\n                    </a>\n                ';
 }); 
__p+='\n                <hr>\n            </div>\n        ';
 } 
__p+='\n\n        <div class="row row-days">\n            <div class="'+
((__t=((canApprove && leaveType.get('name') !== 'Unpaid Leave') ? 'col-sm-6' : 'col-sm-12' ))==null?'':_.escape(__t))+
' text-center">\n                <div class="days">'+
((__t=( model.get('daysRequired') ))==null?'':_.escape(__t))+
'</div>\n                <div>'+
((__t=( (model.get('daysRequired') > 1) ? 'days' : 'day' ))==null?'':_.escape(__t))+
'\n                    required</div>\n            </div>\n            ';
 if (canApprove && leaveType.get('name') !== 'Unpaid Leave') { 
__p+='\n            <div class="col-sm-6 text-center">\n                <div class="days js-allowed"></div>\n                <div class="js-allowed-label">'+
((__t=( require('commons/templates/Spinner.html')() ))==null?'':__t)+
'</div>\n            </div>\n            ';
 } 
__p+='\n        </div>\n\n        ';
 if (model.get('reason')) { 
__p+='\n            <hr />\n            <div class="row">\n                <div class="col-sm-12 text-center">\n                    '+
((__t=( model.get('reason') ))==null?'':_.escape(__t))+
'\n                </div>\n            </div>\n        ';
 } 
__p+='\n\n        ';
 if (statusMessage) { 
__p+='\n            <hr>\n            '+
((__t=( statusMessage ))==null?'':__t)+
'\n        ';
 } 
__p+='\n\n        ';
 if (isCancellable || canCancel || canApprove) { 
__p+='\n            <hr>\n            <div class="text-center">\n                ';
 if (isCancellable && canCancel) { 
__p+='\n                    <button type="button" class="js-cancel-leave btn btn-danger\n                        btn-w-m btn-lg">\n                        Remove Leave\n                    </button>\n                ';
 } 
__p+='\n\n                ';
 if (canApprove) { 
__p+='\n                    <button type="button" class="js-reject btn btn-danger\n                        btn-w-m btn-lg">\n                        Reject\n                    </button>\n                    <button type="button" class="js-approve btn btn-primary\n                        btn-w-m btn-lg m-l">\n                        Approve\n                    </button>\n                ';
 } 
__p+='\n            </div>\n        ';
 } 
__p+='\n\n        ';
 if (!isCancellable && !model.isAwaiting() && !model.isCancelled()) { 
__p+='\n            <hr>\n            <div class="text-center">\n                Cannot be cancelled as payroll for this '+
((__t=( leaveType.get('name').toLowerCase() ))==null?'':_.escape(__t))+
'\n                has already been run\n            </div>\n        ';
 } 
__p+='\n\n        ';
 if (isCancellable && !canCancel && !canApprove) { 
__p+='\n            <div class="row">\n                <div class="col-sm-12 text-center">\n                    <i>Note: This leave cannot be removed by you</i>\n                </div>\n            </div>\n        ';
 } 
__p+='\n    </div>\n\n    ';
 if (canApprove) { 
__p+='\n        <div class="modal-body js-leave-reject" style="display: none">\n            <h2>Enter reject reason:</h2>\n            <textarea class="js-reason form-control" rows="4"></textarea>\n            <div class="text-center m-b-md">\n                <button type="button" class="js-reject-cancel btn btn-default\n                    btn-w-m btn-lg">\n                    Cancel &amp; Back\n                </button>\n                <button type="button" class="js-reject-submit btn btn-success\n                    btn-w-m btn-lg m-l">\n                    Submit\n                </button>\n            </div>\n        </div>\n    ';
 } 
__p+='\n</div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/LeaveRequestModal.ejs
// module id = 897
// module chunks = 1